/**
 * Le anteprime raster (pdf-preview) esistono solo per i PDF: un documento
 * immagine (survey file-upload, allegati WhatsApp, assistente) si mostra
 * cosi' com'e' e non passa mai dalla coda di generazione. Il MIME type non
 * viene persistito su SignedDocument, quindi l'unico segnale disponibile al
 * client e' l'estensione del file originale.
 */
const IMAGE_DOCUMENT_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.heic', '.heif'] as const;

export function isImageDocumentFilename(filename: string): boolean {
  const normalizedFilename = filename.trim().toLowerCase();
  return IMAGE_DOCUMENT_EXTENSIONS.some((extension) => normalizedFilename.endsWith(extension));
}
